<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          PO</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-form >
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="10 ml-auto mr-auto"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <div
                  class="msa-form"
                >
                  <div class="mb-4">
                    <b-img
                      fluid
                      :src="signatureData.logo_path"
                      alt="Company Logo"
                    />
                  </div>
                  <h4 class="text-center mb-2">EXHIBIT A ATTACHED TO CONTRACTOR AGREEMENT</h4>
                  <h2 class="text-underline text-center mb-1">PURCHASE ORDER</h2>
                  <span v-html="signatureData.content"></span>
                  <div class="content-footer">
                    <b-row>
                      <b-col cols="6">
                        <h5>{{ signatureData.company_name }}</h5>
                        <div class="mt-2 mb-50">
                          <span class="d-block signature-line">________________________________</span>
                          <span class="small d-block">(Signature)</span>
                        </div>
                        <h5>Print Name: {{ signatureData.company_user_name }}</h5>
                        <h5>Title: {{ signatureData.company_user_title }}</h5>
                        <h5>Email: {{ signatureData.company_user_email }}</h5>
                        <h5>FED ID: {{ signatureData.company_federal_tax_id }}</h5>
                      </b-col>
                      <b-col cols="6">
                        <h5>Contractor: {{ signatureData.data.employer_company_name }}</h5>
                        <b-button v-show="signatureData.receiver_signature === null" class="btn-outline-warning" variant="flat-primary">
                          Signature
                        </b-button>
                        <div class="mt-2 mb-50">
                          <span class="d-block signature-text" :style="'font-family:' + signatureData.receiver_signature_font ">{{ signatureData.receiver_signature }}</span>
                          <span class="d-block signature-line">________________________________</span>
                          <span class="small d-block">(Signature)</span>
                        </div>
                        <h5>Print Name: {{ signatureData.data.name }}</h5>
                        <div style="display: flex;">
                          <h5 v-show="signatureData.data.title !== null" style="line-height: 24px; margin-bottom: 0;">Title: {{ signatureData.data.title }}</h5>
                        </div>
                        <h5>Email: {{ signatureData.data.email }}</h5>
                        <h5>FED ID: {{ signatureData.data.federal_tax_id }}</h5>
                        <h5 v-show="signatureData.receiver_sign_date !== null">Date: {{ signatureData.receiver_sign_date }}</h5>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BForm, BFormGroup, BButton, BImg,
} from 'bootstrap-vue'
import Esignatures from '@/js/esignatures'

export default {
  name: 'PurchaseOrderDocument',
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BImg,
    BButton,
  },
  setup() {
  },
  data() {
    return {
      accept_consignment: false,
      signatureData: {
        data: {},
      },
      fontTypes: [{ label: 'Bogoritmaa', id: 'Bogoritmaa' }, { label: 'Tyloos', id: 'Tyloos' }, { label: 'Shanghai', id: 'Shanghai' }],
    }
  },
  watch: {
  },
  mounted() {
  },
  created() {
    Esignatures.getDocumentSentById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    setDocumentDetails(data) {
      this.signatureData = data
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@font-face {
    font-family: 'Bogoritmaa';
    src: url('../../../../../fonts/Bogoritmaa.ttf') format('truetype'),
}
@font-face {
    font-family: 'Tyloos';
    src: url('../../../../../fonts/Tyloos.ttf') format('truetype'),
}
@font-face {
    font-family: 'Shanghai';
    src: url('../../../../../fonts/Shanghai.ttf') format('truetype'),
}
focused {
  filter: brightness(1.5);
}
</style>
